<template>
  <div>
    <v-layout class="mt-5 mb-4">
      <h3 class="font-weight-regular">
        {{ school.nmescola }}
      </h3>
    </v-layout>
    <v-layout class="mb-4">
      <v-select
          :loading="loading"
          v-model="segmentoEstoqueSelecionado"
          :items="listaSegmentosEstoque"
          label="Segmento de estoque"
          placeholder="Selecione o segmento de estoque"
          item-text="descricaosegmentoestoqueescola"
          item-value="identificadorsegmentoestoqueescola"
          @change="preencherDataTablePrincipal"
          outlined
          return-object
        ></v-select>
    </v-layout>

    <v-layout class="mb-4">
      <v-text-field
          outlined
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          placeholder="Digite para buscar um item na tabela abaixo"
          single-line
          hide-details
        ></v-text-field>
    </v-layout>

    <v-layout>
      <v-row>
        <v-col>
        <v-skeleton-loader
            max-width="100%"
            v-if="loading"
            type="table-thead, table-tbody, table-tfoot"
          ></v-skeleton-loader>
          <v-data-table
            class="table-siged"
            :loading="loading"
            v-else
            fixed-header
            no-data-text="Nenhum dado encontrado"
            :headers="headers"
            :items="listaDeposito"
            sort-by="descricaoalimentosmar"
            :search="search"
            :items-per-page="10"
            :footer-props="{
                            'items-per-page-text':'Itens por página',
                            'items-per-page-all-text':  'Todos',
                          }"
          >
            <template v-slot:top>
                <v-spacer></v-spacer>
                <v-dialog
                  scrollable
                  v-model="dialog"
                  max-width="600px"
                >
                  <v-card>
                    <v-card-title :class=" (form.acaoDoMovimento === indicadorEntrada ) ?
                    'blue darken-3 elevation-1'
                    : (form.acaoDoMovimento === indicadorRejeicao ) ? 'warning'
                    : 'red darken-3 elevation-1' ">
                      <span class="text-h5 white--text">{{ `${descricaoalimentosmar.substr(0, 25)}... - ${descricaoAcaoMovimento}` }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container class="mt-3">
                        <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
                          <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
                          <div v-if="msgArrayError.length > 0">
                            <ul v-for="error of msgArrayError" :key="error.key">
                              <li>{{ error }}</li>
                            </ul>
                          </div>
                        </v-alert>
                        <v-row no-gutters>
                          <v-col>
                            <Validate :v="$v.form.datahoramovimento">
                              <v-text-field
                                  slot-scope="{ props }"
                                  v-bind="props"
                                  outlined
                                  v-model="form.datahoramovimento"
                                  label="Data/Hora do Movimento*"
                                  readonly
                                ></v-text-field>
                            </Validate>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col >
                            <Validate :v="$v.form.identificadorfornecedor">
                              <v-autocomplete
                                outlined
                                v-if="form.acaoDoMovimento === 'E'"
                                slot-scope="{ props }"
                                v-bind="props"
                                v-model="form.identificadorfornecedor"
                                :search-input.sync="fornecedorSearch"
                                :hide-no-data="!fornecedorSearch && fornecedoresOptions.length == 0"
                                :no-data-text="fornecedoresLoading ? 'Carregando dados, aguarde...' : `Nenhuma opção encontrada com '${fornecedorSearch}'`"
                                :loading="fornecedoresLoading"
                                :items="fornecedoresOptions"
                                hide-selected
                                item-text="nomefornecedor"
                                item-value="identificadorfornecedor"
                                label="Fornecedor*"
                                placeholder="Digite para buscar"
                                prepend-inner-icon="search"
                                @keydown="handleBuscaFornecedor"
                                @click="handleBuscaFornecedor"
                              >
                                <template v-slot:item="{ item }">
                                  <div>{{item.identificadorfornecedor}} - {{item.nomefornecedor}}</div>
                                </template>
                                <template v-slot:selection="{ item }">
                                  <div>{{item.identificadorfornecedor}} - {{item.nomefornecedor}}</div>
                                </template>
                              </v-autocomplete>
                            </Validate>
                          </v-col>
                        </v-row>

                        <v-row no-gutters>
                          <v-col>
                            <Validate :v="$v.form.identificadortipomovimento">
                              <v-autocomplete
                                outlined
                                slot-scope="{ props }"
                                v-bind="props"
                                v-model="form.identificadortipomovimento"
                                :search-input.sync="movimentoSearch"
                                :hide-no-data="!movimentoSearch && movimentosOptions.length == 0"
                                :no-data-text="movimentoLoading ? 'Carregando dados, aguarde...' : `Nenhuma opção encontrada com '${movimentoSearch}'`"
                                :loading="movimentoLoading"
                                :items="movimentosOptions"
                                hide-selected
                                item-text="descricaotipomovimento"
                                item-value="identificadortipomovimento"
                                label="Movimento*"
                                placeholder="Digite para buscar"
                                prepend-inner-icon="search"
                                @keydown="handleBuscaMovimento"
                                @focus="loadMovimentoOptions"
                              >
                                <template v-slot:item="{ item }">
                                  <div>{{item.identificadortipomovimento}} - {{item.descricaotipomovimento}}</div>
                                </template>
                                <template v-slot:selection="{ item }">
                                  <div>{{item.identificadortipomovimento}} - {{item.descricaotipomovimento}}</div>
                                </template>
                              </v-autocomplete>
                            </Validate>
                          </v-col>
                        </v-row>
                        <v-row no-gutters >
                          <v-col cols="5" xs="12">
                            <Validate :v="$v.form.quantidademovimento">
                              <v-text-field
                                outlined
                                slot-scope="{ props }"
                                v-bind="props"
                                v-mask="['#.##', '##.##', '###.##', '####.##', '#####.##', '######.##', '#######.##', '########.##', '#########.##']"
                                v-model="form.quantidademovimento"
                                :label="`Quantidade de ${descricaoAcaoMovimento}*`"
                                maxlength="10"
                              ></v-text-field>
                            </Validate>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="6" xs="12" >
                            <v-text-field
                              outlined
                              v-model="unidademedidaalimento"
                              label="Unidade de Medida"
                              readonly
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row no-gutters >
                          <v-col>
                            <Validate :v="$v.form.numerolotefabricacao">
                              <v-text-field
                                outlined
                                v-if="form.acaoDoMovimento !== indicadorSaida"
                                slot-scope="{ props }"
                                v-bind="props"
                                v-model="form.numerolotefabricacao"
                                label="Nº Lote de Fabricação"
                                maxlength="30"
                                @input="form.numerolotefabricacao = form.numerolotefabricacao.toUpperCase()"

                              ></v-text-field>
                            </Validate>
                          </v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col>
                            <Validate :v="$v.form.datavalidade">
                              <v-text-field
                                outlined
                                slot-scope="{ props }"
                                v-bind="props"
                                v-mask="'##/##/####'"
                                v-model="form.datavalidade"
                                :readonly="form.acaoDoMovimento === indicadorSaida"
                                v-if="form.acaoDoMovimento !== indicadorRejeicao"
                                label="Data de Validade"
                              ></v-text-field>
                            </Validate>
                          </v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col>
                            <Validate :v="$v.form.numeroguiarecebimento">
                              <v-text-field
                                v-if="form.acaoDoMovimento !== indicadorSaida"
                                v-mask="'##########'"
                                outlined
                                slot-scope="{ props }"
                                v-bind="props"
                                v-model="form.numeroguiarecebimento"
                                label="Nº da Guia de Recebimento"
                              ></v-text-field>
                            </Validate>
                          </v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col>
                            <Validate :v="$v.form.observacaomovimento">
                              <v-textarea
                                outlined
                                slot-scope="{ props }"
                                v-bind="props"
                                v-model="form.observacaomovimento"
                                label="Observação"
                                maxlength="100"
                                auto-grow
                                counter
                              ></v-textarea>
                            </Validate>
                          </v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col>
                            <Validate :v="$v.form.identificadorresponsavelmovimento">
                              <v-text-field
                                outlined
                                slot-scope="{ props }"
                                v-bind="props"
                                v-model="form.username"
                                label="Responsável"
                                readonly
                              ></v-text-field>
                            </Validate>
                          </v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col>
                            <Validate :v="$v.fotosDaInspencao">
                              <v-file-input
                                v-if="form.acaoDoMovimento === 'R'"
                                slot-scope="{ props }"
                                v-bind="props"
                                v-model="fotosDaInspencao"
                                counter
                                :counter-string="`${fotosDaInspencao.length} arquivos`"
                                small-chips
                                outlined
                                multiple
                                label="Fotos da inspenção"
                                prepend-icon=""
                                prepend-inner-icon="mdi-camera"
                                :rules="[$v.fotosDaInspencao.isFileSizeValid, $v.fotosDaInspencao.isFileExtensionValid ]"
                                :error-messages="!($v.fotosDaInspencao.isFileSizeValid) ? 'Tamanho máximo permitido por arquivo: 5MB'
                                                  : !($v.fotosDaInspencao.isFileExtensionValid) ? 'Apenas arquivos jpg, jpeg, bmp e png são permitidos'
                                                  : !($v.fotosDaInspencao.limitArraySize) ? 'Por favor, selecionar até 3 arquivos'
                                                  : (!$v.fotosDaInspencao.required && $v.fotosDaInspencao.$dirty) ? 'É obrigatório mandar fotos da inspeção'
                                                  : ''

                                                "
                              ></v-file-input>
                            </Validate>
                          </v-col>
                        </v-row>
                        <v-row>
                        </v-row>
                        <div class="d-flex p-4 justify-center" style="gap: 10px;">
                          <v-btn :loading="loading" color="" class="rounded-sm font-weight-regular" @click="fecharDialog">Cancelar</v-btn>
                          <v-btn :loading="loading" type="submit" color="teal" dark class="rounded-sm font-weight-regular" @click="onSubmit">Salvar</v-btn>
                        </div>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
            </template>

            <template v-slot:item.descricaoalimentosmar="{ item }">
              <div class="py-4">{{ item.descricaoalimentosmar }}</div>
            </template>
            <template v-slot:item.actions="{ item }" style="gap: 10px;">
              <v-icon
                medium
                color="teal"
                class="mr-2"
                @click="movimentarDeposito(item, indicadorEntrada)"
                title="Entrada"
              >
                mdi-plus-box
              </v-icon>
              <v-icon
                medium
                color="error"
                :disabled=" parseInt(item.quantidadeestoque) === 0 "
                @click="movimentarDeposito(item, indicadorSaida)"
                title="Saída"
              >
                mdi-minus-box
              </v-icon>
              <v-icon
                medium
                color="warning"
                title="Rejeição"
                class="mx-2"
                @click="movimentarDeposito(item, indicadorRejeicao)"
              >
                mdi-hand-back-left-off-outline
              </v-icon>
            </template>
            <template v-slot:item.quantidadeestoquetotal="{ item }">
              <v-chip dark :color="corAlertaEstoque(item.quantidadeestoquetotal, item.quantidadeseguranca )">{{ item.quantidadeestoquetotal }}</v-chip>
            </template>
            <template v-slot:item.datavalidade="{ item }">
              <v-chip    v-bind="corAlertaDataValidade(item.datavalidade)">{{ item.datavalidade}}</v-chip>
            </template>

          </v-data-table>
        </v-col>

      </v-row>
    </v-layout>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
    <!-- <img src='http://127.0.0.1:8000/imagens-inspecao-alimentos/a7oRstX5QsyoQ1pfNinxfvBZ538OG6uzqoNA5jcN.png' width="100px" height="100px" /> -->
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import { required, requiredIf, integer, numeric, decimal, maxLength, minValue } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const DepositoDaEscolaRepository = RepositoryFactory.get("depositoDaEscolaRepository");
const tipoMovimentoDepositoRepository = RepositoryFactory.get('tipoMovimentoDeposito')
const FornecedorRepository = RepositoryFactory.get('fornecedorRepository');
const MovimentoDepositoFactory = RepositoryFactory.get('movimentoDepositoFactory')
const SegmentoEstoqueRepository = RepositoryFactory.get("segmentoEstoque")

export default {
  name: 'MovimentoDeposito',
  data() {
    return {
      items: [],
      loading: false,
      acao: '',
      form: this.setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaoalimentosmar',
      buscaOptions: [
        { value: 'identificadoralimentosmar', text: 'Identificador Alimento' },
        { value: 'descricaoalimentosmar', text: 'Descrição Alimento' },
      ],
      movimentoLoading: false,
      cardapioOptions: [],
      cardapiosLoading: false,
      escolaOptions: [],
      escolasLoading: false,
      alimentosLoading: false,
      fornecedoresLoading: false,
      alimentosOptions: [],
      formUltimo: {},
      textoBusca: '',
      searchBusca: '',
      listaOptions: [],
      fornecedoresOptions: [],
      movimentosOptions: [],
      fornecedorSearch: '',
      movimentoSearch: '',
      buscarLoading: false,
      dialog: false,
      search: '',
      headers: [
                {
                  text: 'Alimento',
                  align: 'start',
                  sortable: true,
                  value: 'descricaoalimentosmar',
                  width: '40%'
                },
                {
                  text: 'Estoque Mínimo',
                  align: 'center',
                  sortable: false,
                  value: 'quantidadeseguranca',
                },
                {
                  text: 'Estoque total',
                  align: 'center',
                  sortable: false,
                  value: 'quantidadeestoquetotal',
                },
                {
                  text: 'Unidade de Medida',
                  align: 'center',
                  sortable: false,
                  value: 'unidademedidaalimento',
                },
                {
                  text: 'Data de validade',
                  align: 'center',
                  sortable: false,
                  value: 'datavalidade',
                },
                {
                  text: 'Quantidade',
                  align: 'center',
                  sortable: false,
                  value: 'quantidadeestoque',
                },
                {
                  text: 'Entrada/Saída',
                  value: 'actions',
                  align: 'center'
                }

              ],
      listaDeposito: [],
      indicadorEntrada: 'E',
      indicadorSaida: 'S',
      indicadorRejeicao: 'R',
      descricaoalimentosmar: '',
      unidademedidaalimento: '',
      fotosDaInspencao: [],
      listaSegmentosEstoque: [],
      segmentoEstoqueSelecionado: ''
    };
  },
  computed: {
    ...mapGetters(['school', 'username', 'userDadosPerfilAtual']),
    isFormDisabled() {
      return this.acao == '' || this.acao == 'excluir'
    },
    escola: {
      get() {
        return this.form.cdtipesc && this.form.cdescola ? `${this.form.cdtipesc}-${this.form.cdescola}` : '';
      },
      set(value) {
        if (value === "") {
          this.form.cdtipesc = '';
          this.form.cdescola = '';
          return;
        }
        [this.form.cdtipesc, this.form.cdescola, this.form.identificadorescolalocalexterno] = value.split('-');
      }
    },
    quantidadeEstoque() {
      return (this.alimentosOptions.length === 0) ? 0
            :  parseFloat(this.alimentosOptions.find( a => a.value === this.form.identificadordepositoescola).estoque)
    },
    indicadorstatustipomovimento() {
      const statusmovimento = this.movimentosOptions.find( a => a.identificadortipomovimento === this.form.identificadortipomovimento).indicadorstatustipomovimento
      return (this.movimentosOptions.length === 0 )? ''
             : statusmovimento
    },
    descricaoAcaoMovimento() {
      return (this.form.acaoDoMovimento === 'E') ? 'Entrada'
            : (this.form.acaoDoMovimento === 'S') ? 'Saída'
            :  (this.form.acaoDoMovimento === 'R') ? 'Rejeição'
            : ''
    },
    listaDepositoAgrupado() {
      return _.groupBy(this.listaDeposito, 'descricaoalimentosmar')
    }
  },
  validations: {
    form: {
      identificadordepositoescola: { required },
      identificadortipomovimento: { required, integer },
      identificadorfornecedor: { required: requiredIf( vm => vm.acaoDoMovimento === 'E'),
      integer },
      quantidademovimento: { required, decimal,
        isValid: function(campo, valor, a) {
                  return (this.form.acaoDoMovimento === this.indicadorSaida) ?
                            parseFloat(campo) <= parseFloat(valor.quantidadeestoque)
                          : parseFloat(campo) > 0
        }
       },
      datavalidade: {
                      required: requiredIf( (vm) => vm.acaoDoMovimento != 'R'),
                      isValidDate: function(campo, valor) {
                                     return (!campo) ? true :
                                       moment(campo, 'DD/MM/YYYY').isValid()
                                  },
                      isAfterToday: function(campo, valor) {
                        const datavalidade = moment(campo, 'DD/MM/YYYY').format('YYYY-MM-DD')
                        return (!campo) ? true
                                  : moment(datavalidade, 'YYYY-MM-DD').isSameOrAfter( moment().format('YYYY-MM-DD') )
                      }
                    },
      datahoramovimento: {
                      required,
                      isValidDate: function(campo, valor) {

                                      return (!campo) ? true :
                                       moment(campo, 'DD/MM/YYYY HH:mm:ss').isValid()
                                  },
                    },
      numerolotefabricacao: { maxLength: maxLength(30)},
      observacaomovimento: { maxLength: maxLength(100)},
      // numeroguiarecebimento: { required: requiredIf( (vm) => vm.acaoDoMovimento != 'S'), numeric,  minValue: minValue(0),},
    },
    fotosDaInspencao: {
      required: requiredIf( vm => vm.form.acaoDoMovimento === 'R'),
      isFileSizeValid: function(campo, valor) {
        const fotosMaioresQue5MB = campo.filter( f => parseInt(f.size) > 5000000)
        return fotosMaioresQue5MB.length === 0

      },
      isFileExtensionValid: function(campo, valor) {
        const extensoesPermitidas = ['jpeg','jpg', 'png', 'bmp']
        const extensoes = campo.map( f => f.type.split('/').pop())
        const todasExtValidas = extensoes.every(e => extensoesPermitidas.includes(e));
        return todasExtValidas;
      },
      limitArraySize: function(campo, valor) {
        return campo.length <= 3
      }

    }
  },
  async mounted() {
    this.$Progress.finish();
    await this.buscarSegmentosEstoque()
    await this.preencherDataTablePrincipal()
  },
  methods: {
    setFormInicial() {
      return ({
        identificadormovimentodepositoescola: '',
        identificadordepositoescola: '',
        datavalidade: '',
        descricaoalimentosmar: '',
        datahoramovimento: moment(). format('D/M/Y HH:mm:ss'),
        identificadortipomovimento: '',
        identificadorfornecedor: '',
        quantidademovimento: '',
        numerolotefabricacao: '',
        observacaomovimento: '',
        numeroguiarecebimento: '',
        identificadorresponsavelmovimento: '',
        username: '',
        acaoDoMovimento: '',
      })
    },
    corAlertaEstoque(estoque, estoqueminimo) {

      const perct = parseInt( ((estoque/estoqueminimo ) - 1) * 100)

       if (perct >= 90) {
          return 'teal';
      } else if (perct >= 80) {
        return 'teal darken-1';
      } else if (perct >= 70) {
        return 'teal lighten-1';
      } else if (perct >= 60) {
        return 'teal lighten-2';
      } else if (perct >= 50) {
        return 'teal lighten-3';
      } else if (perct >= 40) {
        return 'orange darken-3';
      } else if (perct >= 30) {
        return 'orange lighten-1';
      } else if (perct >= 20) {
        return 'amber darken-1';
      } else if (perct >= 10) {
        return 'amber lighten-1';
      } else if (perct >= 5) {
        return 'red darken-1';
      } else if (perct > 0) {
        return 'red darken-3';
      } else {
        return 'red darken-4';
      }

    },
    corAlertaDataValidade(datavalidade) {
      const dataAtual = new Date();
      const dataValidade = moment(datavalidade, 'DD/MM/YYYY').toDate();
      const diffTime = dataValidade - dataAtual;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
      if (diffDays < 0) {
          return {
            color:'red dark',
            'text-color': 'white', 
          }
      } else if (diffDays < 45 ) {
          return {            
            color: 'yellow darken-2',
            'text-color': 'white',              
          }
      }  else if (Number.isNaN(diffDays)) {
         return {
          color: "transparent",
         }
      } else {
        return {
          outlined: false,
          color: "transparent",
          // class: "elevation-0",
          }
        }
    },
    async preencherDataTablePrincipal() {

      try {
        this.listaDeposito = []
        this.loading = true
        if(!this.segmentoEstoqueSelecionado) return

        const { data } = await DepositoDaEscolaRepository.buscarDepositoDaEscola(this.school.identificadorescolalocalexterno, {
          identificadorsegmentoestoqueescola: this.segmentoEstoqueSelecionado.identificadorsegmentoestoqueescola
        } )

        this.listaDeposito = data.results
        this.loading = false

      } catch (error) {
        this.msgArrayError = 'Erro ao trazer os dados'
      }
      finally {
        this.loading = false
      }

    },
    async handleBuscaFornecedor(event) {
      clearTimeout(this._searchTimeId)
      this._searchTimeId = setTimeout(async () => {
                                                    await this.loadFornecedoresOptions()
                                                  }, 1000
                                    )
    },
    async handleBuscaMovimento() {
      clearTimeout(this._searchTimeId)
      this._searchTimeId = setTimeout(async () => {
                                                    await this.loadMovimentoOptions()
                                                  }, 1000
                                    )
    },
    async listarRegistros() {
      try {

        this.buscarLoading = true
        const { data } = await DepositoDaEscolaRepository.buscarDepositoDaEscola({
          [this.buscarSelect]:  this.searchBusca,


        })
        this.listaOptions = data.results
      } catch (error) {
        console.error(error)
      }
      finally {
        this.buscarLoading = false

      }
    },

    selectBusca(item) {
      this.form = {
        ...item,
        identificadoralimento: this.form.identificadoralimento,
        identificadordepositoescola: this.form.identificadordepositoescola,
        identificadorescolalocalexterno: this.form.identificadorescolalocalexterno,
        idusuarioatualizacao: this.form.idusuarioatualizacao,
        cdtipesc: this.form.cdtipesc,
        cdescola: this.form.cdescola,
        acaoDoMovimento: this.form.acaoDoMovimento,
        datahoramovimento: moment().format('DD/MM/YYYY HH:mm:ss'),
        identificadorresponsavelmovimento: this.userDadosPerfilAtual.identificadorusuario,
        username: this.username
      }
      this.escola = `${this.form.cdtipesc}-${this.form.cdescola}-${this.form.identificadorescolalocalexterno}`
      this.form.nomeescola = this.school.nmescola

      this.alimentoSearch = item.descricaoalimentosmar
      this.alimentosOptions.push({
        text: item.descricaoalimentosmar,
        value: this.form.identificadoralimento
      })

      this.listaOptions = []
      this.searchBusca = ''
      this.textoBusca = ''

    },
    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        this.loading = true
        const { data } = await MovimentoDepositoFactory.criarMovimentoDeposito({
          ...this.form,
          datahoramovimento: moment(this.form.datahoramovimento, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
          datavalidade: (this.form.datavalidade) ? moment(this.form.datavalidade, 'DD/MM/YYYY').format('YYYY-MM-DD') : '' ,
          acaoDoMovimento: this.form.acaoDoMovimento,
          fotos: this.fotosDaInspencao

        }, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        this.acao = '';
        const acaoDoMovimento = this.form.acaoDoMovimento
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.form.acaoDoMovimento = acaoDoMovimento
        this.formUltimo = { ...this.form };

        this.preencherDataTablePrincipal()
        this.fecharDialog()
        this.fotosDaInspencao = []

      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') {
            this.msgArrayError = error.response.data.errorMessage;
        }
        else {
          this.msgArrayError = ['Erro ao salvar'];
        }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }
      finally {
        this.loading = false

      }

      this.$v.$reset();
    },
    fecharDialog() {
      this.dialog = false;
    },
    async loadFornecedoresOptions() {
      this.fornecedoresLoading = true
      const { data } = await FornecedorRepository.buscarFornecedores({
                                                                      nomefornecedor: this.fornecedorSearch
                                                                    })

      this.fornecedoresOptions = data.results
      this.fornecedoresLoading = false
    },
    async loadMovimentoOptions() {
      this.movimentoLoading = true
      const { data } =  await tipoMovimentoDepositoRepository.buscarTiposMovimentosDeposito({
                                                                                              descricaotipomovimento: this.movimentoSearch ?? '',
                                                                                              indicadorstatustipomovimento: this.form.acaoDoMovimento
                                                                                            })

      this.movimentosOptions = data.results
      this.movimentoLoading = false
    },

    movimentarDeposito(item, acao) {
      this.form = { ...item }
      this.form.cdtipesc = this.school.cdtipesc
      this.form.cdescola = this.school.cdescola
      this.form.identificadorescolalocalexterno = this.school.identificadorescolalocalexterno
      this.unidademedidaalimento = item.unidademedidaalimento
      this.estoqueAtualItemSelecionado =
      this.form.acaoDoMovimento = acao
      this.descricaoalimentosmar = item.descricaoalimentosmar
      this.dialog = true
      this.form.datahoramovimento = moment().format('DD/MM/YYYY HH:mm:ss')
      this.form.identificadorresponsavelmovimento = this.userDadosPerfilAtual.identificadorusuario
      this.form.username = this.username
      this.form.datavalidade = (acao === this.indicadorSaida) ? item.datavalidade : ''
      this.movimentosOptions = []

    },

    async buscarSegmentosEstoque() {
      this.loading = true
      const { data } = await SegmentoEstoqueRepository.buscarSegmentosEstoque()
      this.listaSegmentosEstoque = data.results
      this.loading = false

    }

  },
};
</script>


